import { render, staticRenderFns } from "./SettingGroup.vue?vue&type=template&id=1d155bd0&scoped=true"
import script from "./SettingGroup.vue?vue&type=script&lang=js"
export * from "./SettingGroup.vue?vue&type=script&lang=js"
import style0 from "./SettingGroup.vue?vue&type=style&index=0&id=1d155bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d155bd0",
  null
  
)

export default component.exports